import { findMarketPageKey, type FindMarketPageKeyParams } from '_core/utils/market-pages/findMarketPageKey';

import type { GuidePageContent } from '../types';

export type GuidePageDescriptor = Pick<GuidePageContent, 'key' | 'locale' | 'path' | 'countryIso31661' | 'hosts'>;

const GUIDE_SLUGS = [
  'n8n',
  'geo',
  'automatisation-ia',
  'no-code',
  'developpement-sur-mesure',
  'power-bi',
  'notion',
  'iso-27001',
  'sap',
  'odoo',
] as const;

export const GUIDE_PAGE_DESCRIPTORS: readonly GuidePageDescriptor[] = GUIDE_SLUGS.map((slug) => ({
  key: `fr/guide/${slug}`,
  locale: 'fr',
  path: `/guide/${slug}`,
  countryIso31661: 'FR',
  hosts: ['localhost'],
}));

export const findGuidePageKey = (params: FindMarketPageKeyParams): string | null =>
  findMarketPageKey(GUIDE_PAGE_DESCRIPTORS, params);
